import React from "react";
import { formatDurationMinutes } from "../utils/dashboardTestDuration";

export default function AverageTestDurationChart({ durations, loading }) {
  const items = durations?.items || [];
  const maxAverage = Math.max(...items.map((item) => item.averageMinutes), 1);
  const longestTest = items[0];

  return (
    <section className="dashboard-duration-section">
      <header className="dashboard-duration-header">
        <h2 className="dashboard-duration-title">
          Promedio de tiempos de respuesta en baterías
        </h2>
        <p className="dashboard-duration-subtitle">
          Duración media por tipo de prueba para planificar el tiempo de
          consulta
          {longestTest
            ? `. ${longestTest.testName} toma en promedio ${formatDurationMinutes(longestTest.averageMinutes)}.`
            : "."}
        </p>
      </header>

      {loading ? (
        <p className="dashboard-duration-empty">Cargando tiempos promedio...</p>
      ) : items.length === 0 ? (
        <p className="dashboard-duration-empty">
          Aún no hay tiempos registrados para calcular promedios por prueba.
        </p>
      ) : (
        <div className="dashboard-duration-chart">
          {items.map((item) => (
            <div key={item.testName} className="dashboard-duration-row">
              <span className="dashboard-duration-label" title={item.testName}>
                {item.testName}
              </span>
              <div className="dashboard-duration-bar-track">
                <div
                  className="dashboard-duration-bar-fill"
                  style={{
                    width: `${(item.averageMinutes / maxAverage) * 100}%`,
                  }}
                />
              </div>
              <span className="dashboard-duration-value">
                {formatDurationMinutes(item.averageMinutes)}
              </span>
              <span className="dashboard-duration-sample">
                n={item.sampleSize}
              </span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
